/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData model module.
 * @module model/PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData} The populated <code>PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('transactionCount')) {
                obj['transactionCount'] = ApiClient.convertToType(data['transactionCount'], 'Number');
            }
            if (data.hasOwnProperty('transactionTotalPrice')) {
                obj['transactionTotalPrice'] = ApiClient.convertToType(data['transactionTotalPrice'], 'Number');
            }
            if (data.hasOwnProperty('transactionTotalFee')) {
                obj['transactionTotalFee'] = ApiClient.convertToType(data['transactionTotalFee'], 'Number');
            }
            if (data.hasOwnProperty('registerCount')) {
                obj['registerCount'] = ApiClient.convertToType(data['registerCount'], 'Number');
            }
            if (data.hasOwnProperty('registerTotalPrice')) {
                obj['registerTotalPrice'] = ApiClient.convertToType(data['registerTotalPrice'], 'Number');
            }
            if (data.hasOwnProperty('registerMinPrice')) {
                obj['registerMinPrice'] = ApiClient.convertToType(data['registerMinPrice'], 'Number');
            }
            if (data.hasOwnProperty('registerMaxPrice')) {
                obj['registerMaxPrice'] = ApiClient.convertToType(data['registerMaxPrice'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.prototype['targetDate'] = undefined;

/**
 * @member {Number} transactionCount
 */
PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.prototype['transactionCount'] = undefined;

/**
 * @member {Number} transactionTotalPrice
 */
PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.prototype['transactionTotalPrice'] = undefined;

/**
 * @member {Number} transactionTotalFee
 */
PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.prototype['transactionTotalFee'] = undefined;

/**
 * @member {Number} registerCount
 */
PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.prototype['registerCount'] = undefined;

/**
 * @member {Number} registerTotalPrice
 */
PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.prototype['registerTotalPrice'] = undefined;

/**
 * @member {Number} registerMinPrice
 */
PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.prototype['registerMinPrice'] = undefined;

/**
 * @member {Number} registerMaxPrice
 */
PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData.prototype['registerMaxPrice'] = undefined;






export default PerplayStatisticsControllerDtoMarketVehicleStatisticsMarketData;

